import React from "react";

function SubText({ text }) {
  return <p className="text-[text-[0.938rem] text-[#4E0240]">{text}</p>;
}

export default SubText;
